import { TITLE_PORTAL_TAG_TOOLTIP } from './DocumentUploadSourceTag.constants';

export const getTitlePortalTooltip = uploaderName =>
  uploaderName
    ? `Uploaded by ${uploaderName} through the closing portal`
    : TITLE_PORTAL_TAG_TOOLTIP;
